import { useState, useEffect } from 'react';
import TradingViewChart, { TradingViewChartProps } from './index';

/**
 * Temporary solution to avoid chart crash
 * @param props
 */
const ExchangePlanChangeRemount = (props: TradingViewChartProps) => {
  const [compact, setCompact] = useState(props.compact);
  const [exchange, setExchange] = useState(props.exchange);
  const [kind, setKind] = useState(props.kind);
  const [timeframeExcludes, setTimeframeExcludes] = useState(
    props.timeframeExcludes.length
  );
  const [uniswapLiquidity, setUniswapLiquidity] = useState(
    props.uniswapLiquidity
  );
  const [tokenUnlocks, setTokenUnlocks] = useState(props.tokenUnlocks);
  const [loading, setLoading] = useState(false);

  /**
   * Remount only if we change kind (recreate adapter)
   * or if we change compact "mobile mode"
   * or if we have changes inside exchange when kind != 2
   * or if user pricing plan changed
   */
  useEffect(() => {
    /**
     * Remount when change kind
     */
    if (props.kind !== kind) {
      setLoading(true);
      setKind(props.kind);
    } else {
      // Kind = 2 always use dex datafeed
      if (props.kind != 2) {
        if (props.exchange !== exchange) {
          setExchange(props.exchange);
          setLoading(true);
        }
      }
    }
    /**
     * Remount on compact
     */
    if (props.compact !== compact) {
      setLoading(true);
      setCompact(props.compact);
    }
    /**
     * Remount when pricing plan changed
     */
    if (
      props.timeframeExcludes.length !== timeframeExcludes ||
      props.uniswapLiquidity !== uniswapLiquidity ||
      props.tokenUnlocks !== tokenUnlocks
    ) {
      setLoading(true);
      setTimeframeExcludes(props.timeframeExcludes.length);
      setUniswapLiquidity(props.uniswapLiquidity);
      setTokenUnlocks(props.tokenUnlocks);
    }
  }, [
    props.kind,
    props.exchange,
    props.compact,
    props.timeframeExcludes.length,
    props.uniswapLiquidity,
    props.tokenUnlocks,
    exchange,
    compact,
    kind,
    timeframeExcludes,
    uniswapLiquidity,
    tokenUnlocks,
  ]);

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [loading]);

  if (loading) {
    return <div />;
  }
  return <TradingViewChart {...props} />;
};

export default ExchangePlanChangeRemount;
